export default function CTASection() {
  return (
    <section className="py-16 sm:py-20 bg-gradient-to-br from-[#06C755] to-[#05b34c] text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold mb-4 sm:mb-6">
          あなたらしい働き方を、一緒に見つけませんか?
        </h2>
        <p className="text-lg sm:text-xl mb-6 sm:mb-8 opacity-90">
          ブランクがあっても、時間に制限があっても大丈夫。<br className="hidden sm:block" />
          トラストなら、きっとあなたにぴったりの職場が見つかります。
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a 
            href="https://lin.ee/MJ3LVM2" 
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white hover:bg-gray-100 text-[#06C755] px-6 sm:px-8 py-3 sm:py-4 rounded-full flex items-center space-x-3 text-base sm:text-lg font-medium transition-all whitespace-nowrap cursor-pointer shadow-lg"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-line-fill text-xl"></i>
            </div>
            <span>LINE で気軽に相談する</span>
          </a>
          <a 
            href="tel:052-887-6243" 
            className="bg-white text-[#06C755] px-6 sm:px-8 py-3 sm:py-4 rounded-full flex items-center space-x-3 text-base sm:text-lg font-medium hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer shadow-lg"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-phone-line text-xl"></i>
            </div>
            <span>052-887-6243</span>
          </a>
        </div>
        <p className="text-sm mt-4 sm:mt-6 opacity-75">
          受付:年中無休 9:00-19:00公式LINE:24時間対応
        </p>
      </div>
    </section>
  );
}